import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import uuid from 'react-uuid';
import { ChipListComponent, ChipsDirective, ChipDirective } from '@syncfusion/ej2-react-buttons';
import Form from 'react-bootstrap/Form';
import Typography from '@mui/material/Typography';
import FormControl from 'react-bootstrap/FormControl'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { LocalizationContext } from '../../App';
import NavLink from 'react-bootstrap/NavLink';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ReactSession } from 'react-client-session';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import * as Leaflet from 'leaflet';
import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import { useBeforeunload } from 'react-beforeunload';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { MapContainer, TileLayer, Marker, Popup, Circle, Polygon, MapConsumer, useMapEvents } from 'react-leaflet';

import Slider from '@mui/material/Slider';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { BrowserView, MobileView, isDesktop, isMobile } from 'react-device-detect';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import LoupeMappingSimpleMarker from './LoupeMappingSimpleMarker';
import LoupeActivityItem from './LoupeActivityItem';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';

import OpenInFullIcon from '@mui/icons-material/OpenInFull';

import { useMediaQuery } from 'react-responsive';
import { makeStyles } from "@mui/styles";
import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';

const LoupeMappingSimpleMarkerMapComponent = props => {

    const navigate = useNavigate();

    const isMobileView = useMediaQuery({
        query: '(max-width: 900px)'
    });

   
 
    //const [ state, updateState ] = React.useState();

    const [ selectedMapMode, setSelectedMapMode ] = React.useState(null);
    
    //const forceUpdate = React.useCallback(() => updateState({}), []);

    const item = props.currentItem;
    
    

    const [ markers ] = useState( item['selectedValues'] );
    item['selectedValues'] = markers;

    const handleMapModeChange = (event, newMode) => {
        setSelectedMapMode(newMode);
    }

    const markerSelectedCallbackHandler = (m) => {        
        setEditItem(m);
        setEditorVisibility(true);
    }

    const [ mapperVisibility, setMapperVisibility ] = React.useState(false);
    const [ editorVisibility, setEditorVisibility ] = React.useState(false);
    const [ fullscreenMode, setFullscreenMode ] = React.useState(false);

    const enableFullscreen = () => {
        setFullscreenMode(true);
        openMapper();
    }
    const openMapper = () => {
        setMapperVisibility(true);
    }
    const closeMapper = () => {
        setMapperVisibility(false);
        setFullscreenMode(false);
        setSelectedMapMode(null);
    }

    const [ editItem, setEditItem ] = React.useState(null);
    const handleClose = () => {
        setEditorVisibility(false);
    }

    const markerStyle = ( item.markerStyle != "" ) ? 
    {     
        icon: item.markerStyle.split(':')[0],       
        markerColor: item.markerStyle.split(':')[1],
    } : "";

    const [ stepIndex, setStepIndex ] = React.useState(0);
    const handleJoyrideCallback = (data) => {
      const { action, index, status, type } = data;
  
      if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
        // Update state to advance the tour
        setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1) );
      }
      else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
        // Need to set our running state to false, so we can restart if we click start again.
        // this.setState({ run: false });
      }
  
      // console.groupCollapsed(type);
      // console.log(data); //eslint-disable-line no-console
      // console.groupEnd();
    };
   

    return(

        <LocalizationContext.Consumer>
        { ({strings}) => 


        <React.Fragment>
           
           <div>
                <Form.Floating className="mb-3">
  

                    <LoupeItemHeaderComponent currentItem={item} />

                    { isMobile || fullscreenMode ? (

                        <>
                        <Button onClick={openMapper}>{strings.getString("controls.buttons.activity.mapping.map.open")}</Button>
                        
                        <Dialog
                            fullScreen
                            open={mapperVisibility}>

                        
                        <DialogContent>

                            <div style={{width : '100%', height : '100%', position : 'relative'}}>
                                <div style={{width : '100%', height : '100%', position : 'absolute', top : '0', left : '0', zIndex : '2'}}>

                                    <MapContainer 
                                        className="crosshair mb-4"                                    
                                        touchZoom={true}
                                        style={{height:'100%', width : '100%'}}                                                                                                               
                                        whenCreated={mapInstance => {item.obj = mapInstance}}                                                                                                                        
                                        center={[ item.centerLatitude, item.centerLongitude ]} 
                                        zoom={item.mapZoom}>

                                        <TileLayer  
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                            url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

                                        <LoupeMappingSimpleMarker currentItem={item} selectedMapMode={selectedMapMode} markerSelectedCallbackHandler={markerSelectedCallbackHandler} />

                                    </MapContainer>

                                </div>                               
                              
                                <div style={{ borderRadius : '15px', textAlign : 'center', position : 'absolute', padding : '10px', margin : '10px', bottom : '0', left : '0', right : '0', zIndex : '5' }}>
                                    <Paper style={{ overflowX : 'auto', padding : '10px', marginLeft : 'auto', marginRight : 'auto', width : 'fit-content', maxWidth : '100%' }}>
                                        
                                        <ToggleButtonGroup
                                            exclusive 
                                            value={selectedMapMode}
                                            onChange={handleMapModeChange}>

                                            <ToggleButton
                                                key={"mapmode_add"}
                                                value={"mapmode_add"}>
                                                { markerStyle == "" ? (

                                                    <div>{strings.getString("controls.buttons.activity.mapping.marker.add")}</div>

                                                ) : (

                                                    <div>
                                                        <i className={"fa fa-" + markerStyle.icon} style={{ margin : 4, marginRight : 10, padding : 5, color : 'white', borderRadius : 50, background: markerStyle.markerColor }} />
                                                        <span>{strings.getString("controls.buttons.activity.mapping.marker.add")}</span>
                                                    </div>

                                                )}

                                            </ToggleButton>                                    
                                            <ToggleButton
                                                key={"mapmode_delete"}
                                                value={"mapmode_delete"}>{strings.getString("controls.buttons.activity.mapping.marker.delete")}</ToggleButton>

                                        </ToggleButtonGroup>

                                    </Paper>
                                </div>
                           
                            </div>
                       

                      

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={closeMapper}>{strings.getString("controls.buttons.activity.mapping.map.close")}</Button>
                        </DialogActions>


                    </Dialog>
                    </>

                    ) : (

                        <>

                            <div className="mb-4" style={{ overflowX : 'auto', padding : '10px' }}>
                                <ToggleButtonGroup
                                    exclusive 
                                    value={selectedMapMode}
                                    onChange={handleMapModeChange}>

                                    <ToggleButton
                                        key={"mapmode_add"}
                                        value={"mapmode_add"}>
                                        { markerStyle == "" ? (

                                            <div>{strings.getString("controls.buttons.activity.mapping.marker.add")}</div>

                                        ) : (

                                            <div>
                                                <i className={"fa fa-" + markerStyle.icon} style={{ margin : 4, marginRight : 10, padding : 5, color : 'white', borderRadius : 50, background: markerStyle.markerColor }} />
                                                <span>{strings.getString("controls.buttons.activity.mapping.marker.add")}</span>
                                            </div>

                                        )}

                                    </ToggleButton>
                                   
                                    <ToggleButton
                                        key={"mapmode_delete"}
                                        value={"mapmode_delete"}>{strings.getString("controls.buttons.activity.mapping.marker.delete")}</ToggleButton>

                                </ToggleButtonGroup>
                            </div>

                            <MapContainer 
                                className="crosshair mb-4"
                                dragging={!Leaflet.Browser.mobile}
                                touchZoom={true}
                                style={{height:'50vh'}}                                                                                                               
                                whenCreated={mapInstance => {item.obj = mapInstance}}                                                                                                                        
                                center={[ item.centerLatitude, item.centerLongitude ]} 
                                zoom={item.mapZoom}>

                                <TileLayer  
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

                                <LoupeMappingSimpleMarker currentItem={item} selectedMapMode={selectedMapMode} markerSelectedCallbackHandler={markerSelectedCallbackHandler} />

                            </MapContainer>

                            <Button onClick={enableFullscreen}>
                                <OpenInFullIcon />
                            </Button>

                       
                        </>

                    )


                    }


                   
                    
                   


                    



                    <Dialog open={editorVisibility}>
                    <DialogTitle>{strings.getString("dialogs.activity.mapping.markereditor.title")}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {strings.getString("dialogs.activity.mapping.markereditor.message")}
                        </DialogContentText>
                        
                        { editItem && editItem.markeritems.map(c => {                                 
                                
                                return (                                    
                                    <div key={"wrapper_" + c.id} className="mb-4">                                        
                                         <LoupeActivityItem currentItem={c}/>
                                    </div> 
                                    
                                    ) }
                                )
                        }

                        </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>OK</Button>
                    </DialogActions>
                </Dialog>

                </Form.Floating>

            </div>

        </React.Fragment>

} 
</LocalizationContext.Consumer>



    );


    
}
export default LoupeMappingSimpleMarkerMapComponent;